import React from 'react';
import { Text as ChakraText, TextProps as ChakraTextProps } from '@chakra-ui/react';
import { themeColors } from '../../shared/theme/themeColors';

export function Text(props: ChakraTextProps) {
  return <ChakraText {...props} color={props.color || themeColors.typography.dark} />;
}
